import { Component } from 'react';
import {Navigate} from 'react-router-dom';
import {connect} from 'react-redux';

class RedirectToLogin extends Component {
  static defaultProps = {
    loginPath: '/'
  }

  componentDidMount() {
    const { requestedPath, dispatch } = this.props;

    dispatch({ type: 'SAVE_REQUESTED_PATH', payLoad: requestedPath });
  }

  render() {
    const { loginPath } = this.props;
    return (
      <Navigate to={loginPath} replace/>
    );
  }
}

export default connect()(RedirectToLogin);
